module.exports = __webpack_public_path__ + "static/dominika-d0ea83aea2e428c0a481ea83a0803761.png";